window.addEventListener('DOMContentLoaded', function() {

  // ADD NAVIGATION 
  let door_items = document.querySelectorAll('.header__inline-menu > ul.list-menu > li:nth-child(-n + 3) ul.header__submenu li a');

  for (let i = 0; i < door_items.length; i++) {
    let s1 = door_items[i].innerHTML;
    let s2 = s1.split(/\n/)[1];
    s2 = s2.trim();
    let s3 = s2.split(' ')[0];
    let s4 = s2.split(' ')[1];
    let s5 = '<span>' + s3  + '</span>'

    if(s4 !== undefined){
      s5 = s5 + s4;
    }
    door_items[i].innerHTML = s1.replace(s2, s5);
  }
});